export default __webpack_public_path__ + "static/media/soehne-web-kraftig.f8279ce6.woff2";